import {
  ButtonV2,
  SvgAlertDiamond,
  TextV2,
} from '@insights-ltd/design-library/components';
import { Box, Link } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getRoleDescription } from 'utils/role';
import { DEFAULT_ROUTE } from 'variables';

const RestrictedRouteError = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const navigateToDefaultRoute = () => {
    navigate(DEFAULT_ROUTE);
  };
  const role = t(getRoleDescription(user?.role ?? 'STANDARD'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '1',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100%',
        minHeight: '100%',
      }}
    >
      <Box
        sx={[
          {
            mb: 6,
          },
          (theme) => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '7.5rem',
            width: '7.5rem',
            background: theme.palette.pink.light,
            borderRadius: '50%',
            '& > svg': {
              fill: theme.palette.pink.dark,
              height: '3.75rem',
              width: '3.75rem',
            },
          }),
        ]}
      >
        <SvgAlertDiamond title="alert" />
      </Box>
      <TextV2 variant="h1" component="h1">
        {t('ui.event-management.restricted-route.error.title')}
      </TextV2>
      <Box
        sx={{
          mt: 3,
          maxWidth: 560,
          textAlign: 'center',
        }}
      >
        <TextV2 component="p">
          <Trans
            i18nKey="ui.event-management.restricted-route.error.content"
            values={{ role }}
            components={{
              strong: <TextV2 variant="h1" />,
            }}
          />
        </TextV2>
        <TextV2 component="span">
          <Trans
            i18nKey="ui.event-management.restricted-route.error.contact-customer-services"
            values={{ emailAddress: 'customerservice@insights.com' }}
            components={[
              <Link
                key="1"
                href="mailto:customerservice@insights.com"
                sx={{ fontWeight: 600, padding: '0.5rem' }}
              />,
            ]}
          />
        </TextV2>
        <TextV2 component="p">
          <ButtonV2
            sx={{ margin: '1rem' }}
            buttonText={t(
              'ui.event-management.restricted-route.error.contact-customer-services.return-link',
            )}
            onClick={navigateToDefaultRoute}
            component={Link}
            role="button"
          />
        </TextV2>
      </Box>
    </Box>
  );
};

export default RestrictedRouteError;
